export const OFFERS_LINK = 'https://dorim.com/public-offer';
export const BANK_LOAN_OFFER_LINK = 'https://dorim.com/loan-offer';
export const PROCESSING_OF_PERSONAL_DATA_LINK = 'https://dorim.com/privacy-policy';
export const LANDING_PAGE_LINK = 'https://dorim.com/';
export const SUPPORT_PHONE_CALLTO = '+998781137755';
export const SUPPORT_PHONE_FORMATTED = '+998 (78) 113-77-55';
export const TELEGRAM_CHAT_LINK = 'https://t.me/Dorim_support_bot';
export const TELEGRAM_CHANNEL_LINK = 'https://t.me/dorim_news';
export const DORIM_PROMO_NOTION_LINK = 'https://dorim-uz.notion.site/Astra-Zeneca-34aff91b32e34c3c8d019235aeb99d74';
